import { render, staticRenderFns } from "./icon-send.vue?vue&type=template&id=d0859cae&scoped=true&"
import script from "./icon-send.vue?vue&type=script&lang=js&"
export * from "./icon-send.vue?vue&type=script&lang=js&"
import style0 from "./icon-send.vue?vue&type=style&index=0&id=d0859cae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0859cae",
  null
  
)

export default component.exports